import { render, staticRenderFns } from "./ListUsersRating.vue?vue&type=template&id=79409944&scoped=true"
import script from "./ListUsersRating.vue?vue&type=script&lang=js"
export * from "./ListUsersRating.vue?vue&type=script&lang=js"
import style0 from "./ListUsersRating.vue?vue&type=style&index=0&id=79409944&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79409944",
  null
  
)

export default component.exports